// Projects data. Add new projects by appending to this array — the /projects page
// scales automatically. Each project has its own /projects/:slug detail page.
//
// Copy accuracy: fields here are limited to what the customer-facing description
// establishes and what a photo shows. No inferred outcomes, invented locations,
// invented client goals, or unspecified services. When more information is
// supplied later, expand carefully.
export const PROJECTS = [
  {
    slug: "commonwealth-equipment",
    title: "Illuminated Building Sign",
    description:
      "New headquarters branding package featuring illuminated signage and dimensional lettering.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/uglx0z9b_Commonwealth%20Equipment%20Corporation.png",
    relatedServicePage: "/commercial-signs-richmond-va",
    relatedServiceLabel: "Commercial Signs in Richmond, VA",
  },
  {
    slug: "bee-charmed",
    title: "Storefront Channel Letters",
    description:
      "Exterior storefront signage designed to improve visibility and strengthen brand presence.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/eg70eq83_BeeCharmed.png",
    relatedServicePage: "/storefront-signs-richmond-va",
    relatedServiceLabel: "Storefront Signs in Richmond, VA",
  },
  {
    slug: "glenside-medical",
    title: "Medical Office Signage",
    description:
      "Exterior building signage and supporting branding elements for a healthcare facility.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/zzgukrdy_Glenside%20Medical.png",
    relatedServicePage: "/commercial-signs-richmond-va",
    relatedServiceLabel: "Commercial Signs in Richmond, VA",
  },
  {
    slug: "granger-genetics",
    title: "Dimensional Letter Signage",
    description:
      "Custom dimensional lettering designed to create a professional appearance and improve building identification.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/j2isgswf_Granger%20Monument.png",
    relatedServicePage: "/monument-signs-richmond-va",
    relatedServiceLabel: "Monument Signs in Richmond, VA",
  },
  {
    slug: "mosaic-group",
    title: "Monument Sign Refurbishment",
    description:
      "Existing monument sign updated to improve visibility and appearance while working within site constraints.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/03swaq5r_Mosaic%20Design%20Center.png",
    relatedServicePage: "/monument-signs-richmond-va",
    relatedServiceLabel: "Monument Signs in Richmond, VA",
  },
  {
    slug: "cross-keys",
    title: "Neighborhood Sign Repair",
    description:
      "Damaged entrance sign repaired and restored to extend its service life and improve appearance.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/4b8gdz49_Cross%20Keys%20Neighborhood%20Sign%20Repair.png",
    relatedServicePage: "/commercial-signs-richmond-va",
    relatedServiceLabel: "Commercial Signs in Richmond, VA",
  },
  {
    slug: "aspire-church",
    title: "Storefront Window Graphics",
    description:
      "Window graphics installation designed to communicate key information and improve visibility.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/dkry3x87_Aspire%20Community%20Church.png",
    relatedServicePage: "/storefront-signs-richmond-va",
    relatedServiceLabel: "Storefront Signs in Richmond, VA",
  },
  {
    slug: "loehr-lightning",
    title: "Vehicle Graphics & Lettering",
    description:
      "Vehicle graphics package designed to reinforce branding and increase visibility on the road.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/fmvxlbg5_LoehrLightning.png",
    relatedServicePage: "/commercial-signs-richmond-va",
    relatedServiceLabel: "Commercial Signs in Richmond, VA",
  },
  {
    slug: "target",
    title: "Retail Receive & Install",
    description:
      "Receive-and-install project for a national retail location. Signage was received, staged, and installed to manufacturer specifications.",
    coverImage:
      "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/tp4azdsr_Target%20Receive%20and%20Insetall.png",
    relatedServicePage: "/sign-installation-richmond-va",
    relatedServiceLabel: "Sign Installation in Richmond, VA",
  },
];
